export default {
  DOCUMENT_CLASSIFICATIONS: (state) => {
    return state.documentClassifications;
  },
  DOCUMENT_CLASSIFICATIONS_LOADING: (state) => {
    return state.documentClassificationsLoading;
  },
  DOCUMENT_EXTRACT_TEMPLATES: (state) => {
    return state.documentExtractTemplates;
  },
  DOCUMENT_EXTRACT_TEMPLATES_LOADING: (state) => {
    return state.documentExtractTemplatesLoading;
  },
};